import classNames from 'classnames';
import { Icon, ContentBlock, FlexContainer, Txt, View } from 'components';
import { formatCurrency } from 'helpers/formatNumber';
import { fromSwiftDate } from 'helpers/swiftDateFormatter';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import { useTenancy } from 'state';
import styles from './TenancyViewPayments.module.scss';

/**
 * TenancyViewPayments
 *
 * @return {JSX.Element}
 */
const TenancyViewPayments = ({ className }) => {
  const { data: tenancy } = useTenancy();
  // const [isModalOpen, setModalOpen] = useState('');

  const handleRentClick = () => {
    // setModalOpen('rent');
  };
  const handleDepositClick = () => {
    // setModalOpen('deposit');
  };
  // const handleCloseModal = () => setModalOpen('');

  return (
    <FlexContainer
      className={classNames(
        styles.TenancyViewPayments,
        className,
        TenancyViewPayments.displayName
      )}
      column
      gap
    >
      <ContentBlock alignCenter onClick={handleRentClick}>
        <FlexContainer column flex gapHalf>
          <Txt caption>Rent</Txt>
          <View>
            <Txt xxx bold>
              £{formatCurrency(tenancy.payments.rentAmount)}
            </Txt>
            <Txt caption>/month</Txt>
          </View>
          <Txt>
            Due{' '}
            {DateTime.fromJSDate(
              fromSwiftDate(tenancy.dates.rentDueDates[0])
            ).toLocaleString(DateTime.DATE_FULL)}
          </Txt>
        </FlexContainer>
        <Icon name="currency" />
      </ContentBlock>
      <ContentBlock alignCenter black onClick={handleDepositClick}>
        <FlexContainer column flex gapHalf>
          <Txt caption>Deposit</Txt>
          <View>
            <Txt xxx bold>
              £{formatCurrency(tenancy.payments.depositAmountPaid)}
            </Txt>
            <Txt caption>
              /£{formatCurrency(tenancy.payments.depositAmount)}
            </Txt>
          </View>
          <Txt>
            Due{' '}
            {DateTime.fromJSDate(
              fromSwiftDate(tenancy.dates.depositDue)
            ).toLocaleString(DateTime.DATE_FULL)}
          </Txt>
        </FlexContainer>
        <Icon name="secure" />
      </ContentBlock>
      {/*{isModalOpen ? (*/}
      {/*  <Modal onClose={handleCloseModal} noPadding>*/}
      {/*    {isModalOpen === 'deposit' ? (*/}
      {/*      <ViewPaymentsDeposit />*/}
      {/*    ) : (*/}
      {/*      <ViewPaymentsRent />*/}
      {/*    )}*/}
      {/*  </Modal>*/}
      {/*) : null}*/}
    </FlexContainer>
  );
};

TenancyViewPayments.displayName = 'TenancyViewPayments';

export default observer(TenancyViewPayments);
